// Shared "Classroom tools" fieldset: high-contrast demo mode for dim
// projectors and predict mode, which hides the readout answers until the
// teacher reveals them after learners have made their predictions.
export function ClassroomTools({
  classroomMode,
  predictMode,
  onToggleClassroomMode,
  onTogglePredictMode,
}: {
  readonly classroomMode?: boolean;
  readonly predictMode: boolean;
  readonly onToggleClassroomMode?: () => void;
  readonly onTogglePredictMode: () => void;
}) {
  return (
    <fieldset className="control-group classroom-tools">
      <legend>Classroom tools</legend>
      {classroomMode === undefined ? null : (
        <label className="checkbox-control">
          <input
            checked={classroomMode}
            type="checkbox"
            onChange={onToggleClassroomMode}
          />
          Classroom demo mode
        </label>
      )}
      <label className="checkbox-control">
        <input
          checked={predictMode}
          type="checkbox"
          onChange={onTogglePredictMode}
        />
        Predict mode — hide answers
      </label>
    </fieldset>
  );
}

export function RevealAnswersButton({
  revealed,
  onToggle,
}: {
  readonly revealed: boolean;
  readonly onToggle: () => void;
}) {
  return (
    <button className="reveal-answers" type="button" onClick={onToggle}>
      {revealed ? "Hide answers again" : "Reveal answers"}
    </button>
  );
}
